import { Page } from '../types'
import ExternalLink from '../../components/ExternalLink'

type GetSupportProps = { }

const render = () => {
    return <>
        <h3>Questions</h3>
        <p>
            If you get stuck during installation of Gurobi during your evaluation, or want to discuss
            your architecture or optimization model in more detail, feel free
            to reach out to your Technical Account Manager by e-mail; we're happy
            to help! Alternatively you can create a <a href="https://support.gurobi.com/" target="_blank" rel="noreferrer">support
            ticket</a>.            
        </p>

        <h3>Sharing a model</h3>
        <p>
            Often it's useful for us to have a look at your mathematical model,
            especially if you're looking for ways to speed up the solver process.
            Using Gurobi you can export your model <ExternalLink href="https://www.gurobi.com/documentation/{version}/refman/model_file_formats.html">in various file formats</ExternalLink>.
            Have a look at the "Tips and tricks" page for instructions.
            You can then <ExternalLink href="https://www.gurobi.com/upload-a-model/">upload your model here</ExternalLink>. 
            Do mention the name of your Technical Account Manager in the comments field.
        </p>
    </>
}


const GetSupport : Page<GetSupportProps> = { key: 'get-support', title: 'Getting support', render }

export default GetSupport